<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Teelt</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="col-form-label" for="afdeling">Afdeling <sup>*</sup></label>
                                    <select @change="fillBelichtingsuren" type="text" v-model="model.afdeling_id" id="afdeling" name="afdeling" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('afdeling') }" >
                                        <template v-for="afdeling in afdelingen">
                                            <option :value="afdeling.id" :selected="afdeling.id == (model.afdeling && model.afdeling_id)">{{afdeling.naam}} - {{afdeling.bedrijf.naam}}</option>
                                        </template>
                                    </select>
                                    <span class="small text-danger" v-show="errors.has('afdeling')">Kies een afdeling</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="teelt">Teelt <sup>*</sup></label>
                                    <select type="text" v-model="model.teelt_id" id="teelt" name="teelt" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('teelt') }" >
                                        <template v-for="teelt in teelten">
                                            <option :value="teelt.id" :selected="teelt.id == (model.teelt && model.teelt_id)">{{teelt.naam}}</option>
                                        </template>
                                    </select>
                                    <span class="small text-danger" v-show="errors.has('teelt')">Kies een teelt</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="ras">Ras <sup>*</sup></label>
                                    <input type="text" v-model="model.ras" id="ras" name="ras" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('ras') }" />
                                    <span class="small text-danger" v-show="errors.has('ras')">Ras is verplicht</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label">Aanplantdatum <sup>*</sup></label>
                                    <input type="date" @change="haveAanplantdatum" class="unstyled" v-model="model.aanplantdatum" name="aanplantdatum" id="aanplantdatum" ref="aanplantdatum" />
                                    <span v-show="!model.aanplantdatum" class="small text-danger">Aanplantdatum is verplicht</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label">Einddatum <sup>*</sup></label>
                                    <input type="date" @change="haveEinddatum" class="unstyled" v-model="model.einddatum" name="einddatum" id="einddatum" ref="einddatum" />
                                    <span v-show="!model.einddatum" class="small text-danger">Einddatum is verplicht</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="aantalDagenTotVolgroeid">Aantal dagen tot volgroeid <sup>*</sup></label>
                                    <input type="number" step="1" min="0" max="999" v-model="model.aantalDagenTotVolgroeid" id="aantalDagenTotVolgroeid" name="aantalDagenTotVolgroeid" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('aantalDagenTotVolgroeid') }" />
                                    <span class="small text-danger" v-show="errors.has('aantalDagenTotVolgroeid')">Aantal dagen is verplicht</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="ingesteldeDli">Ingestelde DLI <sup>*</sup> <span class="small">(mol/m<sup>2</sup>)</span></label>
                                    <input type="number" step=".1" min="0" max="99.9" v-model="model.ingesteldeDli" id="ingesteldeDli" name="ingesteldeDli" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('ingesteldeDli') }" />
                                    <span class="small text-danger" v-show="errors.has('ingesteldeDli')">Ingestelde DLI is verplicht</span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="col-form-label" for="aantalStengelsPerPlant">Aantal stengels/plant</label>
                                    <input type="number" step="1" min="0" max="999" v-model="model.aantalStengelsPerPlant" id="aantalStengelsPerPlant" name="aantalStengelsPerPlant" class="form-control" />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="col-form-label" for="afstandInRij">Afstand in rij <span class="small">(cm)</span></label>
                                    <input type="number" step=".1" min="0" max="999.9" v-model="model.afstandInRij" id="afstandInRij" name="afstandInRij" class="form-control" />
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="col-form-label" for="rijafstand">Rijafstand <span class="small">(cm)</span></label>
                                    <input type="number" step=".1" min="0" max="999.9" v-model="model.rijafstand" id="rijafstand" name="rijafstand" class="form-control" />
                                </div>
                            </div>
                        </div>

                    </form>
                </b-card>
            </div>

            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i class='fa fa-align-justify'></i><strong> Invloedspercentages</strong>
                    </div>
                    <form>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="aantalDagenVerleden">Aantal dagen verleden <sup>*</sup></label>
                                    <select @change="changeDmins" type="text" v-model="model.aantalDagenVerleden" id="aantalDagenVerleden" name="aantalDagenVerleden" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('aantalDagenVerleden') }" >
                                        <template v-for="aantal in aantalDagen">
                                            <option :value="aantal" :selected="aantal == model.aantalDagenVerleden">{{aantal}}</option>
                                        </template>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="percentageVerleden">Percentage verleden <sup>*</sup></label>
                                    <input type="number" step="1" min="0" max="999" v-model="model.percentageVerleden" id="percentageVerleden" name="percentageVerleden" v-validate="'required'" :class="{'form-control': true, 'is-invalid': (errors.has('percentageVerleden') || percVerledenFout) }"  />
                                    <span v-show="percVerledenFout" class="small text-danger">Percentage is 0</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-show="model.aantalDagenVerleden != 0">
                            <div class="col-sm-12">
                                <table>
                                    <tr>
                                        <template v-for="(dmin, index) in model.dmins">
                                            <td>
                                                <label class="col-form-label">D{{dmin.dagverschil}} <sup>*</sup></label>
                                            </td>
                                        </template>
                                    </tr>
                                    <tr>
                                        <template v-for="(dmin, index) in model.dmins">
                                            <td >
                                                <input style="width: 5em" type="number" step="1" min="0" max="999" v-model="dmin.waarde" name="waarde" :data-vv-name="'waarde' + index" v-validate="'required'" :class="{'form-control': true, 'is-invalid': (errors.has('waardep' + index) || (totmins !== 100)) }" />
                                            </td>
                                        </template>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="row" v-show="model.aantalDagenVerleden != 0">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <small>
                                        <label :class="{'text-danger': totmins !== 100 }" class="col-form-label">Totaal percentages verleden</label>
                                        <label :class="{'text-danger': totmins !== 100 }">{{totmins}} %</label>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="aantalDagenToekomst">Aantal dagen toekomst <sup>*</sup></label>
                                    <select @change="changeDplus" type="text" v-model="model.aantalDagenToekomst" id="aantalDagenToekomst" name="aantalDagenToekomst" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('aantalDagenToekomst') }" >
                                        <template v-for="aantal in aantalDagen">
                                            <option :value="aantal" :selected="aantal == model.aantalDagenToekomst">{{aantal}}</option>
                                        </template>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" for="percentageToekomst">Percentage toekomst <sup>*</sup></label>
                                    <input type="number" step="1" min="0" max="999" v-model="model.percentageToekomst" id="percentageToekomst" name="percentageToekomst" v-validate="'required'" :class="{'form-control': true, 'is-invalid': (errors.has('percentageToekomst') || percToekomstFout) }"  />
                                    <span v-show="percToekomstFout" class="small text-danger">Percentage is 0</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-show="model.aantalDagenToekomst != 0">
                            <div class="col-sm-12">
                                <table>
                                    <tr>
                                        <template v-for="(dplus, index) in model.dplus">
                                            <td v>
                                                <label class="col-form-label">D+{{dplus.dagverschil}} <sup>*</sup></label>
                                            </td>
                                        </template>
                                    </tr>
                                    <tr>
                                        <template v-for="(dplus, index) in model.dplus">
                                            <td>
                                                <input style="width: 5em" type="number" step="1" min="0" max="999" v-model="dplus.waarde" name="waardep" :data-vv-name="'waardep' + index" v-validate="'required'" :class="{'form-control': true, 'is-invalid': (errors.has('waardep' + index) || (totplus !== 100)) }" />
                                            </td>
                                        </template>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="row" v-show="model.aantalDagenToekomst != 0">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <small>
                                        <label :class="{'text-danger': totplus !== 100 }" class="col-form-label">Totaal percentages toekomst</label>
                                        <label :class="{'text-danger': totplus !== 100 }">{{totplus}} %</label>
                                    </small>
                                </div>
                            </div>
                        </div>

                    </form>
                </b-card>
            </div>

        </div>

        <div class="row">
            <div class="col-lg-12">
                <b-card>
                    <div slot="header">
                        <i class='fa fa-align-justify'></i><strong> Belichtingsuren</strong>
                    </div>
                    <form @submit.prevent="saveItem">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="col-form-label">Startdatum belichting <sup>*</sup></label>
                                    <input type="date" @change="haveStartdatumBelichting" class="unstyled" v-model="model.startdatumBelichting" name="startdatumBelichting" id="startdatumBelichting" ref="startdatumBelichting" />
                                    <span v-show="!model.startdatumBelichting" class="small text-danger">Startdatum is verplicht</span>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="col-form-label">Einddatum belichting <sup>*</sup></label>
                                    <input type="date" @change="haveEinddatumBelichting" class="unstyled" v-model="model.einddatumBelichting" name="einddatumBelichting" id="einddatumBelichting" ref="einddatumBelichting" />
                                    <span v-show="!model.einddatumBelichting" class="small text-danger">Einddatum is verplicht</span>
                                </div>
                            </div>
                        </div>

                        <div v-show="model.aantalBelichtingen != 0">
                            <table class="table table-striped table-sm">
                                <thead>
                                    <tr>
                                        <th>Naam belichting</th>
                                        <th>Soort</th>
                                        <th>Startuur belichting <sup>*</sup></th>
                                        <th>Lengte lichtperiode <sup>*</sup></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template  v-for="(belichtingsuur, index) in model.belichtingsuren_n">
                                        <tr>
                                            <td class="align-middle">
                                                <label class="form-control-static">{{belichtingsuur.belichting.naam}}</label>
                                            </td>
                                            <td class="align-middle">
                                                <label class="form-control-static">{{belichtingsuur.belichting.soortbelichting.naam}}</label>
                                            </td>
                                            <td>
                                                <input type="time" class="unstyled" v-model="belichtingsuur.startuurBelichting" :id="'startuurBelichting' + index" name="startuurBelichting" :data-vv-name="'startuurBelichting' + index" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('startuurBelichting' + index) }" />
                                                <span class="small text-danger" v-show="errors.has('startuurBelichting')">Kies een startuur belichting</span>
                                            </td>
                                            <td>
                                                <input type="number" step=".1" min="0" max="99.9" v-model="belichtingsuur.lengteLichtperiode" :id="'lengteLichtperiode' + index" name="lengteLichtperiode" :data-vv-name="'lengteLichtperiode' + index" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('lengteLichtperiode' + index) }" />
                                                <span class="small text-danger" v-show="errors.has('lengteLichtperiode')">Lengte lichtperiode is verplicht</span>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>

                        </div>

                        <div slot="footer">
                            <b-button type="submit" variant="primary">
                                <span>Opslaan</span>
                            </b-button>
                            <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                        </div>
                    </form>
                </b-card>
            </div>

        </div>

        <div style="height: 11em"></div>
    </div>
</template>

<script>

    import api from '../../api/afdeling';

    export default {
        name: 'Form',
        props: ['model', 'afdelingen', 'teelten', 'isEditing'],
        data () {
            return {
                aantalDagen: [0, 1, 2, 3, 4, 5, 6],
            };
        },
        methods: {
            mindate () {
                var datum = arguments[0];
                for (var i = 0; i < arguments.length; i++) {
                    if (arguments[i] != undefined) {
                        if (arguments[i] < datum) {
                            datum = arguments[i];
                        }
                    }
                }
                return datum;
            },
            maxdate () {
                var datum = arguments[0];
                for (var i = 0; i < arguments.length; i++) {
                    if (arguments[i] != undefined) {
                        if (arguments[i] > datum) {
                            datum = arguments[i];
                        }
                    }
                }
                return datum;
            },
            haveAanplantdatum () {
                document.getElementById("startdatumBelichting").setAttribute("min", this.model.aanplantdatum);
                document.getElementById("einddatumBelichting").setAttribute("min", this.maxdate(this.model.aanplantdatum,this.model.startdatumBelichting));
                document.getElementById("einddatum").setAttribute("min", this.maxdate(this.model.aanplantdatum,this.model.startdatumBelichting,this.model.einddatumBelichting));
                //alert(this.model.einddatumBelichting);
            },
            haveEinddatum () {
                document.getElementById("aanplantdatum").setAttribute("max", this.mindate(this.model.einddatum,this.model.einddatumBelichting,this.model.startdatumBelichting));
                document.getElementById("startdatumBelichting").setAttribute("max", this.mindate(this.model.einddatum,this.model.einddatumBelichting));
                document.getElementById("einddatumBelichting").setAttribute("max", this.model.einddatum);
            },
            haveStartdatumBelichting () {
                document.getElementById("aanplantdatum").setAttribute("max", this.model.startdatumBelichting);
                document.getElementById("einddatumBelichting").setAttribute("min", this.model.startdatumBelichting);
                document.getElementById("einddatum").setAttribute("min", this.maxdate(this.model.startdatumBelichting,this.model.einddatumBelichting));
            },
            haveEinddatumBelichting () {
                document.getElementById("aanplantdatum").setAttribute("max", this.mindate(this.model.einddatumBelichting,this.model.startdatumBelichting));
                document.getElementById("startdatumBelichting").setAttribute("max", this.model.einddatumBelichting);
                document.getElementById("einddatum").setAttribute("min", this.model.einddatumBelichting);
            },
            fillBelichtingsuren() {
                api.getBelichtingsuren(this.model.afdeling_id).then((response) => {
                    this.model.aantalBelichtingen = response.data.aantalBelichtingen;
                    this.model.belichtingsuren_n = response.data.belichtingsuren_n;
                });
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!this.isError) {
                            this.$emit('save-item', this.model);
                        }
                    }
                });
            },
            changeDmins () {
                const max = this.model.aantalDagenVerleden;
                if (max === 0) {
                    this.model.percentageVerleden = 0;
                }
                if (max > this.model.dmins.length) {
                    for (let i = (this.model.dmins.length + 1); i <= max; i += 1) {
                        this.model.dmins.push({ afdelingteelt_id: this.model.id,
                            dagverschil: -i,
                            waarde: '' });
                    }
                } else if (max < this.model.dmins.length) {
                    this.model.dmins.splice(max, this.model.dmins.length - max);
                }
            },
            changeDplus () {
                const max = this.model.aantalDagenToekomst;
                if (max === 0) {
                    this.model.percentageToekomst = 0;
                }
                if (max > this.model.dplus.length) {
                    for (let i = (this.model.dplus.length + 1); i <= max; i += 1) {
                        this.model.dplus.push({ afdelingteelt_id: this.model.id,
                            dagverschil: i,
                            waarde: '' });
                    }
                } else if (max < this.model.dplus.length) {
                    this.model.dplus.splice(max, this.model.dplus.length - max);
                }
            },
            back () {
                this.$router.go(-1);
            },
        },
        computed: {
            isError () {
                return (!this.model.aanplantdatum) ||
                    (!this.model.einddatum) ||
                    (!this.model.startdatumBelichting) ||
                    (this.percVerledenFout) ||
                    (this.percToekomstFout) ||
                    (this.totPercVerledenFout) ||
                    (this.totPercToekomstFout);
            },
            totmins () {
                let result = 0;
                for (let i = 0; i < this.model.dmins.length; i += 1) {
                    if (this.model.dmins[i].waarde !== '') {
                        result += parseInt(this.model.dmins[i].waarde, 10);
                    }
                }
                return result;
            },
            percVerledenFout () {
                return (parseInt(this.model.aantalDagenVerleden, 10) !== 0) &&
                    (parseInt(this.model.percentageVerleden, 10) === 0);
            },
            percToekomstFout () {
                return (parseInt(this.model.aantalDagenToekomst, 10) !== 0) &&
                    (parseInt(this.model.percentageToekomst, 10) === 0);
            },
            totPercVerledenFout () {
                return (parseInt(this.model.aantalDagenVerleden, 10) !== 0) &&
                    (this.totmins !== 100);
            },
            totPercToekomstFout () {
                return (parseInt(this.model.aantalDagenToekomst, 10) !== 0) &&
                    (this.totplus !== 100);
            },
            totplus () {
                let result = 0;
                for (let i = 0; i < this.model.dplus.length; i += 1) {
                    if (this.model.dplus[i].waarde !== '') {
                        result += parseInt(this.model.dplus[i].waarde, 10);
                    }
                }
                return result;
            },
        },
        components: {
        },
    };
</script>

<style>

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .unstyled::-webkit-outer-spin-button, /* Removes arrows */
    .unstyled::-webkit-inner-spin-button, /* Removes arrows */
    .unstyled::-webkit-clear-button { /* Removes blue cross */
      -webkit-appearance: none;
      margin: 0;
    }
    /*.unstyled::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }*/
</style>



// WEBPACK FOOTER //
// src/pages/afdelingteelt/Form.vue